import { render, staticRenderFns } from "./TriggersTable.vue?vue&type=template&id=454824f0"
import script from "./TriggersTable.vue?vue&type=script&lang=js"
export * from "./TriggersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports